import React from "react";
import { Chip, Box } from "@mui/material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Icon } from "@fluentui/react/lib/Icon";

interface Segment {
  type: "OU" | "DC";
  value: string;
}

interface ActiveDirectoryOUSortableChipProps {
  segment: Segment;
  index: number;
  onDelete: () => void;
}

const ActiveDirectoryOUSortableChip: React.FC<ActiveDirectoryOUSortableChipProps> = ({ segment, index, onDelete }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: index.toString() });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  if (!segment) return null;

  return (
    <Chip
      ref={setNodeRef}
      style={style}
      label={`${segment.type}=${segment.value}`}
      {...attributes}
      {...listeners}
      color={segment.type === "OU" ? "success" : "primary"}
      onDelete={onDelete}
      deleteIcon={
        <Box
          onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onDelete();
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "progress",
            "&:hover": { color: "error.main" },
          }}
        >
          <Icon iconName="Cancel" style={{ fontSize: "small", opacity: 0.5 }} />
        </Box>
      }
      variant="outlined"
      sx={{
        fontFamily: "monospace",
        fontWeight: 500,
        "& .MuiChip-deleteIcon": {
          marginLeft: 0,
          marginRight: 0.5,
        },
        "&:hover .MuiChip-deleteIcon": {
          color: "inherit",
        },
        userSelect: "none",
        "&:active": {
          cursor: "grabbing",
        },
        cursor: "grab",
      }}
    />
  );
};

export default ActiveDirectoryOUSortableChip;
